import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import Button from './Button';
import Logo from './Logo';
import AdvisorIcon from './AdvisorIcon';
import PWAInstallButton from './PWAInstallButton';

export default function AppShell({ authed, onLogout, children }) {
  const location = useLocation();
  const isLogin = location.pathname.startsWith('/login');

  return (
    <div className="app">
      <header className="appHeader">
        <div className="container appHeader__inner">
          <Link to={authed ? '/products' : '/login'} className="appHeader__brandLink">
            <Logo />
          </Link>

          <nav className="appHeader__nav">
            {authed && !isLogin && (
              <>
                <Link
                  to="/products"
                  className={`appHeader__navLink ${location.pathname === '/products' ? 'active' : ''}`}
                >
                  Producten
                </Link>
                <Link
                  to="/advisor"
                  className={`appHeader__navLink ${location.pathname === '/advisor' ? 'active' : ''}`}
                >
                  <span className="navIcon" aria-hidden="true">
                    <AdvisorIcon size={18} />
                  </span>
                  Adviseur
                </Link>
              </>
            )}
          </nav>

          <div className="appHeader__actions">
            {!isLogin && <PWAInstallButton />}
            {authed && !isLogin && (
              <Button variant="ghost" size="sm" type="button" onClick={onLogout}>
                Uitloggen
              </Button>
            )}
          </div>
        </div>
      </header>

      <main className="container appMain">{children ?? <Outlet />}</main>

      <footer className="appFooter">
        <div className="container appFooter__inner">
          <span>© {new Date().getFullYear()} PremTech</span>
          <span className="muted">Data via premtech.nl</span>
        </div>
      </footer>
    </div>
  );
}
